import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import {
  selectCrossClientHasActions,
  selectCrossClientResultsExecution,
  selectCrossClientSearch,
  selectCrossClientSelectedTab,
} from '../../../store/crossClient/crossClientResults'
import { CrossClientResultTabs, type CrossClientResultTab } from '../../../models/CrossClient'
import { executionIsRunning } from '../../../store/crossClient/utils'
import accessRequiredIllustration from '../../../assets/images/cross-client-logo.png'

const RESULT_TYPE_TEXT: Record<CrossClientResultTab, string> = {
  [CrossClientResultTabs.MATCH]: 'matches',
  [CrossClientResultTabs.POTENTIAL]: 'potential matches',
  [CrossClientResultTabs.REMAINING]: 'remaining clients',
  [CrossClientResultTabs.NO_MATCH]: 'clients without a match',
  [CrossClientResultTabs.MISSING_DATA]: 'clients with missing data',
}

export const CrossClientTableEmptyState: React.FC = () => {
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const selectedTab = useAppSelector(selectCrossClientSelectedTab)
  const search = useAppSelector(selectCrossClientSearch)
  const hasActions = useAppSelector(selectCrossClientHasActions)

  const isRunning = executionIsRunning(execution)
  const noun = RESULT_TYPE_TEXT[selectedTab]
  const clientName = search.clientName?.trim()

  const actionsLabel = hasActions === true ? 'with actions' : hasActions === false ? 'without actions' : null
  const filterParts = [clientName ? `for "${clientName}"` : null, actionsLabel].filter(Boolean)

  const { title, description } = filterParts.length
    ? { title: 'No results found', description: `No ${noun} found ${filterParts.join(' ')}.` }
    : isRunning
      ? selectedTab === CrossClientResultTabs.MATCH
        ? { title: 'No full matches yet', description: 'The query is running. Full matches will appear here.' }
        : { title: `No ${noun} yet`, description: "The query is still running. Results will appear here as they're found." }
      : { title: `No ${noun} found`, description: `This query has no ${noun}.` }

  return (
    <div className='d-flex flex-column align-items-center justify-content-center gap-3 zocks-pt-7.5 pb-4'>
      <img src={accessRequiredIllustration} alt='' className='cross-client-logo' />
      <div className='d-flex flex-column gap-2 align-items-center justify-content-center cross-client-no-result-content'>
        <h5 className='mb-0'>{title}</h5>
        <p className='paragraph-medium text-center zocks-text-gray-600 mb-0'>{description}</p>
      </div>
    </div>
  )
}
